import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setAuthState } from 'loot-core/client/actions';
import { send } from 'loot-core/platform/client/fetch';

import countries from '../../../countries.json';
import { theme } from '../../../style';
import { Autocomplete } from '../../autocomplete/Autocomplete';
import { ButtonWithLoading } from '../../common/Button';
import { Input } from '../../common/Input';
import { Text } from '../../common/Text';
import { View } from '../../common/View';
import { FormField, FormLabel } from '../../forms';
import { useAuth } from '../../../hooks/useAuth';

type MyProfileProps = {};

export function MyProfileForm({}: MyProfileProps) {
  const dispatch = useDispatch();
  const { getUser, reloadUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [country, setCountry] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    (async () => {
      const profile = await getUser();

      setName(profile.name);
      setEmail(profile.email);
      setCountry(profile.country);
    })();
  }, []);

  async function onSubmit(e) {
    e.preventDefault();

    if (loading) {
      return;
    }

    setLoading(true);
    await send('subscribe-update-profile', { email, name, country });
    await dispatch(setAuthState({ username: name }));
    await reloadUser();
    setLoading(false);

    setMsg('Your profile has been updated.');
  }

  return (
    <View style={{ overflow: 'auto' }}>
      {msg && (
        <Text
          style={{
            marginTop: 20,
            marginBottom: 20,
            color: theme.noticeTextLight,
            borderRadius: 4,
            fontSize: 15,
          }}
        >
          {msg}
        </Text>
      )}

      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 10,
        }}
        onSubmit={onSubmit}
      >
        <FormField style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row' }}>
            <FormLabel title="Your email address" htmlFor="Email" />
            &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
          </View>
          <Input
            type="email"
            name="email"
            value={email}
            required={true}
            disabled={true}
            style={{ backgroundColor: theme.formInputBackground }}
            onChange={e => {
              setEmail(e.target.value);
            }}
          />
        </FormField>
        <FormField style={{ flex: 1 }}>
          <View style={{ flexDirection: 'row' }}>
            <FormLabel
              title="What you would like us to call you"
              htmlFor="name"
            />
            &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
          </View>
          <Input
            type="text"
            name="name"
            value={name}
            required={true}
            onChange={e => {
              setName(e.target.value);
            }}
          />
        </FormField>
        <FormField style={{ flex: 1 }}>
          <FormLabel title="What country are you in" htmlFor="country" />
          <Autocomplete
            strict
            suggestions={countries.map(country => ({
              id: country.name,
              name: country.name,
            }))}
            inputProps={{
              autoComplete: 'off',
            }}
            onSelect={value => {
              setCountry(value);
            }}
            value={country}
          />
        </FormField>

        <ButtonWithLoading type="primary" loading={loading}>
          Save changes
        </ButtonWithLoading>
      </form>
    </View>
  );
}
